import { FC, useRef, useState } from 'react';

import { Icon } from '@shared/components/icons';

export const CustomerDepositInfoBox: FC = function CustomerDepositInfoBox() {
  const { CashAccount } = Icon();
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    if (!isExpanded) {
      setTimeout(() => {
        contentRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 100);
    }
  };

  return (
    <div className="p-4 py-2 pb-4 theme-bg-1" ref={contentRef}>
      <div className="relative cursor-pointer select-none" onClick={handleToggle}>
        <div className="center-box gap-2 pr-6">
          <CashAccount />
          <p className="font-bold">화환 구매용 입금계좌</p>
        </div>
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-1 text-sm font-bold theme-text-main">
          <span
            className={`transition-transform duration-200 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          >
            ▼
          </span>
          <span>{isExpanded ? '접기' : '펼치기'}</span>
        </div>
      </div>

      {isExpanded && (
        <div className="mt-4 space-y-4">
          <div className="center-box gap-6 font-bold">
            <div className="center-box flex-col items-center break-keep">
              <p className="">입금계좌</p>
              <p className="text-14 theme-text-main">(주)가온프라임</p>
            </div>
            <div className="break-keep text-base">
              <p className="theme-text-main">기업은행</p>
              <p>137-115848-04-019</p>
            </div>
          </div>
          <div className="center-box">
            <div className="text-center font-medium">
              <p>위 계좌는 화환구매를 위한 입금계좌입니다</p>
              <p className="font-bold text-warn">※부의금을 보내시면 안됩니다※</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
